import { takeLatest } from 'redux-saga/effects';
import {
  CHANGE_AUTO_PROLONG,
  CHECK_SERVICE_AFTER_CHANGE_BET,
  CHECK_SERVICE_AFTER_FILL_BALANCE,
} from '../../actions/checkoutInfo';
import {
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PLACING_PERIOD,
  SELECT_PUBLISH_TERMS_SERVICE,
  SET_IS_SERVICES_ENABLED,
} from '../../actions/publishTerms';
import { SET_TERMS_DURATION } from '../../actions/termsDurations';
import { checkService } from './checkService';

export function* checkoutInfoSagas() {
  yield takeLatest(
    [
      SELECT_PUBLISH_TERMS_SERVICE,
      LOAD_PUBLISH_TERMS_SUCCESS,
      SELECT_PLACING_PERIOD,
      CHANGE_AUTO_PROLONG,
      CHECK_SERVICE_AFTER_CHANGE_BET,
      CHECK_SERVICE_AFTER_FILL_BALANCE,
      SET_IS_SERVICES_ENABLED,
      SET_TERMS_DURATION,
    ],
    checkService,
  );
}
